import { createEnv } from "@t3-oss/env-core";
import { z } from "zod";

export const env = createEnv({
  client: {
    VITE_PORTAL_APP_DISABLE_NAV: z.string().optional(),
    VITE_PORTAL_APP_DISABLE_ROUTING: z.string().optional(),
    VITE_PORTAL_APP_NAME: z.string(),
    VITE_PORTAL_APP_TITLE: z.string(),
  },

  /**
   * The prefix that client-side variables must have. This is enforced both at
   * a type-level and at runtime.
   */
  clientPrefix: "VITE_",

  /**
   * By default, this library will feed the environment variables directly to
   * the Zod validator.
   *
   * This means that if you have an empty string for a value that is supposed
   * to be a number (e.g. `PORT=` in a ".env" file), Zod will incorrectly flag
   * it as a type mismatch violation. Additionally, if you have an empty string
   * for a value that is supposed to be a string with a default value (e.g.
   * `DOMAIN=` in an ".env" file), the default value will never be applied.
   *
   * In order to solve these issues, we recommend that all new projects
   * explicitly specify this option as true.
   */
  emptyStringAsUndefined: true,

  /**
   * What object holds the environment variables at runtime. This is usually
   * `process.env` or `import.meta.env`.
   */
  // @ts-ignore
  runtimeEnv: {
    VITE_PORTAL_APP_DISABLE_NAV: import.meta.env.VITE_PORTAL_APP_DISABLE_NAV,
    VITE_PORTAL_APP_DISABLE_ROUTING: import.meta.env
      .VITE_PORTAL_APP_DISABLE_ROUTING,
    VITE_PORTAL_APP_NAME: import.meta.env.VITE_PORTAL_APP_NAME,
    VITE_PORTAL_APP_TITLE: import.meta.env.VITE_PORTAL_APP_TITLE,
  },
});
